import React from "react";

export default function PayrollSummaryCard({ title, value, subtitle }) {
  return (
    <div className="payroll-card payroll-summary-card">
      <p className="payroll-summary-title">{title}</p>
      <h3>{value}</h3>
      {subtitle ? <span>{subtitle}</span> : null}
    </div>
  );
}
